import React from 'react';
import CSelect, { Error } from 'src/components/form/Select';
import { riskEventsOptions, RiskEvents } from 'src/api/types';
import { ActionMeta, Props, Theme } from 'react-select';
import { DefaultTheme } from 'styled-components';

type Option = { label: string; value: RiskEvents };
type OptionGroup = { label: string; options: Option[] };

interface EventsSelectProps extends Omit<Props<Option>, 'value'> {
  theme?: Theme & DefaultTheme;
  value?: RiskEvents | null;
  onChange?: (value: Option, meta: ActionMeta<Option>) => void;
}

const getValue = (opts: (Option | OptionGroup)[], val?: RiskEvents | null) => {
  const data = opts.reduce<Option[]>((acc, curr) => {
    if ('options' in curr) {
      return [...acc, ...curr.options];
    } else {
      return [...acc, curr];
    }
  }, []);

  return data.find((o) => o.value === val) || null;
};

export const EventsSelect: React.FC<EventsSelectProps> = ({ value, ...other }) => {
  return (
    <>
      <CSelect
        value={getValue(riskEventsOptions, value)}
        placeholder="Select event"
        options={riskEventsOptions}
        inputId="events-select"
        {...other}
      />
      {other.error && other.helperText && <Error>{other.helperText}</Error>}
    </>
  );
};
